export default __webpack_public_path__ + "static/media/pin.b6136878.svg";